import * as React from 'react';

import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import EntityName from 'components/entity/entity-name/EntityName';
import MetricsChannelsBasic from 'components/metrics/channels-basic/MetricsChannelsBasic';

import ContentCard from 'components/cards/content-card/ContentCard';

import { __t, applyTranslations } from 'utils/language';
import { getEntityFromProfile } from 'utils/view';
import { prepareDataForMetricsChannelsBasic } from 'utils/metrics';
import {
  DELIVERABLE_TYPE_INSTAGRAM_POST as IG_POST_TYPE,
  DELIVERABLE_TYPE_INSTAGRAM_REEL as IG_REEL_TYPE,
  DELIVERABLE_TYPE_INSTAGRAM_STORY as IG_STORY_TYPE,
  DELIVERABLE_TYPE_TIKTOK_VIDEO as TT_VIDEO_TYPE,
  DELIVERABLE_TYPE_YOUTUBE_VIDEO as YT_VIDEO_TYPE
} from 'utils/deliverables';

import './notable-likes-card.scss';

import type { ChannelTypes } from 'types';
import type {
  ContentCardCreatorProfile,
  ContentCard as ContentCardType
} from 'components/cards/content-card/types';

applyTranslations(require('./shared/notable-likes-card-shared.i18n.json'));

type Props = {
  creatorFollower: Partial<ContentCardCreatorProfile>,
  channel: ChannelTypes,
  contentCard: ContentCardType,
  onNoPostClick: () => void
};

const MSG_KEY = 'notable_likes_card_shared';

const TYPE_TRANSLATIONS = {
  [IG_POST_TYPE]: 'post',
  [IG_REEL_TYPE]: 'reel',
  [IG_STORY_TYPE]: 'story',
  [TT_VIDEO_TYPE]: 'video',
  [YT_VIDEO_TYPE]: 'video'
};

const NotableLikesCard = ({
  creatorFollower,
  channel,
  contentCard,
  onNoPostClick
}: Props): JSX.Element => {
  const entity = getEntityFromProfile(creatorFollower);
  const metricsChannels = prepareDataForMetricsChannelsBasic(creatorFollower, channel);
  const cardType = contentCard.item.type || IG_POST_TYPE;

  return (
    <div className="notable-likes-card">
      <div className="notable-likes-card__follower">
        <div className="notable-likes-card__avatar-container">
          <div className="notable-likes-card__avatar">
            <EntityAvatar
              bordered
              openInNewTab
              entity={entity}
              link={entity?.url}
              customSize={{
                width: 120,
                height: 120
              }}
            />
          </div>
          <div className="notable-likes-card__avatar-shadow" />
        </div>
        <div className="notable-likes-card__name">
          <EntityName
            openInNewTab
            entity={entity}
            link={entity?.url}
          />
        </div>
        <div className="notable-likes-card__metrics">
          <MetricsChannelsBasic
            channels={[metricsChannels]}
            showChannels={[channel]}
            type="limited"
            includeRatio
          />
        </div>
        <div className="notable-likes-card__byline">
          {__t(`${MSG_KEY}.labels.liked_this`, {
            contentType: __t(`${MSG_KEY}.labels.${TYPE_TRANSLATIONS[cardType]}`)
          })}
        </div>
      </div>
      <ContentCard
        {...contentCard}
        suppressBoxShadow
        onNoPostClick={onNoPostClick}
      />
    </div>
  );
};

export default NotableLikesCard;
